import React from 'react';
import { Title } from '@upsales/components';
import { Input } from '@upsales/components';
import type { EditWidgetRowProps, WidgetDataSourceProps } from '../hooks/integrations/externalIntegrationTypes';
import useTagTranslator from './useTagTranslator';

export const EditUiWidgetTitle = ({ row, onUpdate }: EditWidgetRowProps) => {
	const text = row.settings?.text || '';

	const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		onUpdate({
			...row,
			settings: {
				...row.settings,
				text: e.target.value
			}
		});
	};

	return <Input value={text} onChange={handleChange} />;
};

const UiWidgetTitle: React.FC<WidgetDataSourceProps> = ({ row, dataSources, widgetSettings }) => {
	const size = row.settings?.size;

	const translatedText = useTagTranslator(row.settings, dataSources, widgetSettings);

	return (
		<div className="UiWidget__title">
			<Title size={size}>{translatedText}</Title>
		</div>
	);
};

export default UiWidgetTitle;
